module.exports = __webpack_public_path__ + "static/img/专业团队@2x.4806704.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/专业团队@2x.png
// module id = 1SvN
// module chunks = 0